module.exports = __webpack_public_path__ + "media/images/top/keisan_club_graph-min-677bf4e0225043f7c3b30822421eb44c.png";